import {
    restQuery,
    QueryResult,
    BaseModel,
    restMutation,
    MutationResult,
} from 'vue-apollo-model';
import { BaseDataResponse } from '@/type';

export const InitPageNum = '1';

export interface AnnouncementListItem {
    content: string;
    noticeTime: number;
    tags: string[];
    title: string;
    id: number;
}

export interface AnnouncementListType {
    total: number;
    pageSize: number;
    announcements: AnnouncementListItem[];
}
export type AnnouncementResponse = BaseDataResponse<AnnouncementListType>;
export type AnnouncementInfoResponse = BaseDataResponse<AnnouncementListItem>;
export class InformModel extends BaseModel {
    @restQuery<InformModel>({
        url: '/portal/announcement/list',
        method: 'get',
        variables($route) {
            return {
                pageNum: $route.query.pageNum || +InitPageNum,
                pageSize: 10,
            };
        },
        skip($route) {
            return $route.name === 'informDetail';
        },
    })
    announcementListQuery!: QueryResult<AnnouncementResponse>;
    get total() {
        return this.announcementListQuery.data.data?.total || 1;
    }

    get list() {
        return this.announcementListQuery.data.data?.announcements || [];
    }

    @restQuery<InformModel>({
        url: '/portal/announcement/info',
        method: 'get',
        variables($route) {
            return {
                announcementId: $route.query.id,
            };
        },
        skip($route) {
            return $route.name !== 'informDetail';
        },
    })
    announcementInfoQuery!: QueryResult<AnnouncementInfoResponse>;
    get inform() {
        return (
            this.announcementInfoQuery.data.data || {
                title: '',
                content: '',
                noticeTime: 0,
                tags: [],
            }
        );
    }
    get isDetailError() {
        return (
            !!this.announcementInfoQuery.error ||
            (this.announcementInfoQuery.data.result &&
                this.announcementInfoQuery.data.result !== 1)
        );
    }
}
